import { createGetApi } from "@api/util/createGetApi";

import type { IApiResponse } from "@api";

import type { IFilterResponse } from "../types";

import type { IPathBaseParam } from "./path";

const getApi = createGetApi<
  IApiResponse<IFilterResponse>,
  IPathBaseParam,
  undefined
>("filters.warehouse");

export const warehouse = {
  ...getApi,
};
